(function() {
    'use strict';

    // Simple hash function to generate a unique hash for each post
    function generatePostHash(postId, postSlug) {
        // Combine post ID and slug for uniqueness
        const input = `${postId}-${postSlug}-${new Date().getFullYear()}`;
        
        // Simple hash algorithm
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
            const char = input.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32-bit integer
        }
        
        // Convert to base58-like string (similar to Solana hashes)
        const chars = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
        let result = '';
        let absHash = Math.abs(hash);
        
        // Generate a 44-character hash (similar to Solana hash length)
        for (let i = 0; i < 44; i++) {
            result += chars[absHash % chars.length];
            absHash = Math.floor(absHash / chars.length) + i * 7919; // Add some variation
            
            // Add more variation using the input string
            if (i < input.length) {
                absHash += input.charCodeAt(i) * (i + 1);
            }
        }
        
        return result;
    }

    // Initialize post hashes on page load
    function initPostHashes() {
        const hashContainers = document.querySelectorAll('.post-hash-container');
        
        hashContainers.forEach(container => {
            const postId = container.getAttribute('data-post-id');
            const postSlug = container.getAttribute('data-post-slug');
            const hashValue = container.querySelector('.post-hash-value');
            
            if (postId && postSlug && hashValue) {
                // Generate hash
                const hash = generatePostHash(postId, postSlug);
                
                // Animate the hash appearance
                setTimeout(() => {
                    hashValue.textContent = hash;
                    hashValue.style.transition = 'opacity 0.3s ease';
                    hashValue.style.opacity = '1';
                }, 300);
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPostHashes);
    } else {
        initPostHashes();
    }
    
    // Also initialize on theme change
    window.addEventListener('themeChanged', initPostHashes);
})();